import { InMemoryCache } from '@apollo/client';
import { capitalize, uniqBy } from 'lodash/fp';

export const cache = () =>
  new InMemoryCache({
    typePolicies: {
      DogBreeder: {
        fields: {
          displayName: {
            read(displayName: string | null) {
              if (displayName == null) return null;
              const split = displayName?.split(' ').map((x) => capitalize(x.toLocaleLowerCase()));
              return split?.join(' ');
            },
          },
          breedingName: {
            read(breedingName: string | null) {
              if (breedingName == null) return null;
              return capitalize(breedingName.toLowerCase());
            },
          },
        },
      },
      DogBreederTranslation: {
        fields: {
          name: {
            read(name: string | null) {
              if (name == null) return null;
              return capitalize(name.toLowerCase());
            },
          },
        },
      },
      Query: {
        fields: {
          account: {
            keyArgs: ['id'],
          },
          litters: {
            keyArgs: ['where', 'orderBy'],
            merge(existing = [], incoming) {
              const newData = [...existing, ...incoming];
              const formatted = uniqBy('__ref', newData);
              return formatted;
            },
          },
          findManyDogShelter: {
            keyArgs: ['where', 'take', 'orderBy'],
            merge(existing = [], incoming) {
              const newData = [...existing, ...incoming];
              const formatted = uniqBy('__ref', newData);
              return formatted;
            },
          },
          translateText: {
            keyArgs: ['textToTranslate', 'originalLang', 'targetLang'],
          },
          findManyAnimal: {
            keyArgs: ['where'],
            merge(existing = [], incoming) {
              const newData = [...existing, ...incoming];
              const formatted = uniqBy('__ref', newData);
              return formatted;
            },
          },
          findManyNotification: {
            keyArgs: false,
            merge(existing = [], incoming) {
              const items = existing.items ? existing.items.concat(incoming.items) : incoming.items;
              const formatted = uniqBy('__ref', items);
              return { ...incoming, items: formatted };
            },
          },
          findManyAnnouncement: {
            keyArgs: false,
            merge: (existing, incoming) => {
              if (!existing) {
                return incoming;
              }
              if (!incoming) {
                return existing;
              }
              return [...existing, ...incoming];
            },
          },
        },
      },
    },
  });
